import { render, staticRenderFns } from "./qSidebarAdminCustomer.vue?vue&type=template&id=690fe012&"
import script from "./qSidebarAdminCustomer.vue?vue&type=script&lang=ts&"
export * from "./qSidebarAdminCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports